import { ContentLayout } from '@connected/ui/layouts/content/layout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/projects/$projectVersionId/quotation')({
    component: Layout,
});

function Layout() {
    return (
        <ContentLayout>
            <ContentLayout.Outlet />
        </ContentLayout>
    );
}
